import React, { useMemo } from "react";
import { SubscribedChart } from "@client/components/valueDisplays/SubscribedChart";
import type { TracerTelemetry } from "@client/types/tracer";

interface Props {
  slug: string;
  telemetry: TracerTelemetry | undefined;
}

/**
 * Grafy vývoje v čase pro detail Tracer nabíječe (záložka Flow) — stejný graf jako hlavní
 * stránka, nad MQTT topicy, které Tracer publikuje. Hlavička PV grafu ukazuje ŽIVOU hodnotu
 * (pvPowerW) shodnou s overview; graf kreslí 15s-průměrovanou MQTT řadu.
 *
 *  - PV výkon v čase (pv-w)
 *  - kumulativní energie dnes (energy-gen-today-kwh) = integrál výkonu, který tracer počítá v HW
 *    (bez override — ve flow tabu není konkurenční živé číslo)
 */
export const TracerCharts: React.FC<Props> = ({ slug, telemetry }) => {
  const prefix = `zige/tracer-${slug}`;
  // Memoizace topic polí na prefix — jinak by se inline pole měnilo každý telemetry tick
  // a Chart2 by se zbytečně re-renderoval.
  const pvPower = useMemo(() => [`${prefix}/pv-w/val`], [prefix]);
  const energyToday = useMemo(() => [`${prefix}/energy-gen-today-kwh/val`], [prefix]);

  return (
    <>
      <SubscribedChart topicIds={pvPower} liveValue={telemetry?.pvPowerW} />
      <SubscribedChart topicIds={energyToday} />
    </>
  );
};
